import React, { Component } from 'react'
import styled from 'styled-components'
import { Input, Popconfirm, Button, Form, Tooltip } from 'antd'
import ReactTable from 'react-table'
import moment from 'moment'
import { filterCaseInsensitive } from '../../../../util'

const FormItem = Form.Item

const AddItemsContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`

class Notes extends Component {
  onNoteInputChange = e => {
    this.setState({
      noteContent: e.target.value
    })
  }

  handleAddEditNote = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (this.props.currentNote) {
        values.updated_by_id = this.props.userId
        values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')

        this.props.updateNote(values)
      } else {
        values.created_by_id = this.props.userId
        values.updated_by_id = this.props.userId
        values.created_date = moment().format('YYYY/MM/DD HH:mm:ss')
        values.updated_date = moment().format('YYYY/MM/DD HH:mm:ss')

        this.props.createNote(values)
      }

      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { noteAddEditContainer, notes, deleteNote } = this.props
    return (
      <div>
        <div className="jobsBar">
          Notes
          <div className="jobsBarAdd" onClick={() => this.props.handleToggleNoteEditArea()}>
            <i className="fa fa-pencil-square" aria-hidden="true" />
            &nbsp;<div className="addJobLabel">ADD NOTE</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {noteAddEditContainer && (
              <AddItemsContainer>
                <Form>
                  <div className="row">
                    <div className="col-md-12">
                      <FormItem label="Content">
                        {getFieldDecorator('content', {
                          rules: [
                            {
                              required: true,
                              message: 'Content cannot be blank.'
                            }
                          ],
                          initialValue: this.props.currentNote ? this.props.currentNote.content : ''
                        })(<Input />)}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <Popconfirm
                        title="Are you sure you want to delete this record?"
                        onConfirm={deleteNote}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        {this.props.currentNote && (
                          <Button type="danger" icon="delete" className="mr-2" />
                        )}
                      </Popconfirm>
                      <Button onClick={() => this.handleAddEditNote()}>
                        {this.props.currentNote ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </div>
                </Form>
              </AddItemsContainer>
            )}
            <ReactTable
              data={notes}
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.props.handleRowNoteClick(rowInfo.original)
              })}
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Content',
                      id: 'content',
                      accessor: d => d.content,
                      Cell: d => <Tooltip title={d.original.content}>{d.original.content}</Tooltip>
                    },
                    {
                      Header: 'Created Date',
                      id: 'created_date',
                      accessor: d => moment.utc(d.created_date).format('MM/DD/YYYY'),
                      minWidth: 40
                    },
                    {
                      Header: 'Created By',
                      id: 'created_by',
                      accessor: d => `${d.first_name_created_by} ${d.last_name_created_by}`,
                      minWidth: 40
                    }
                  ]
                }
              ]}
              defaultPageSize={5}
              className="-striped -highlight"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Form.create()(Notes)



// WEBPACK FOOTER //
// ./src/pages/lead/components/notes/Notes.component.js